/**
 * Asynchronously loads the component for EmailTemplatesCreateEditPage
 */

import { lazyLoad } from 'utils/loadable';
import LoadingIndicator from 'app/components/LoadingIndicator';

export const EmailTemplatesCreateEditPage = lazyLoad(
  () => import('./index'),
  module => module.EmailTemplatesCreateEditPage,
  { fallback: <LoadingIndicator /> },
);
